import React, {FC, useState, useEffect, useCallback} from 'react'
import {useFormContext} from 'react-hook-form'
import {
  SelectWrapper,
  SelectAsyncWrapper,
  InputNumberWrapper,
  InputTextWrapper,
  CheckWrapper,
} from '../../../../../../components/UI/Form/Input'
import {UserModel, PersonModel} from '../../../../model'
import {getUserById, getPerson, getDocumentByPerson} from '../../../../services'
import {useCentral} from '../../../../../../hooks/useCentral'
import {useTableMaster} from '../../../../hooks'
import useEnterpriseService, {
  ENTERPRISE_SEARCH_MIN_LENGTH,
} from '../../../../hooks/useEnterpriseService'
import useCecoService from '../../../../hooks/useCecoService'
import {AddPerson} from '../Modal/ModalAddPerson'
import {KTableLoading} from '../../../../../../components/UI'
import {initValues} from '../../../../util/values/users'
import {TITLE_FORM_USER} from '../../../../util/Constants'
import AditionalForm from '../../../../../../components/UI/Form/aditionalCamp/aditionalCampCentral'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
import {
  isDocTypeAlphaNumeric,
  isDocTypeWithPersonLookupFlow,
} from '../../../../util/documentTypeHelpers'
const User: FC = () => {
  const {setError, setValue, watch, reset} = useFormContext()
  const {currentTabItem, isAllowed} = useCentral()
  const {statusUser, getStatusUserList, docType, getDocTypeList, statusAccess, getStatusAccessList} = useTableMaster()
  const {getEnterpriseSearchOptions, getEnterpriseOptionById} = useEnterpriseService()
  const [empresaContratanteOption, setEmpresaContratanteOption] = useState<{
    value: any
    label: string
  } | null>(null)
  const [empresaSubcontratistaOption, setEmpresaSubcontratistaOption] = useState<{
    value: any
    label: string
  } | null>(null)
  const {ceco, getCECOList} = useCecoService()
  const [maxLength, setMaxLength] = useState(0)
  const [documentoPersona, setDocumentoPersona] = useState<PersonModel[] | any>([])
  const [loading, setLoading] = useState(false)
  const [loadUser, setLoadUser] = useState(false)
  const [showModalNew, setShowModalNew] = useState(false)
  const [detailDocument, setDetailDocument] = useState<any>(null)
  const empresaSubcontratistaId = watch('empresaSubcontratistaId') || ''
  let numeroDocumentoChangeTimeout: any
  const numeroDocumento = watch('numeroDocumento') || ''
  const tipoDocumento = watch('tipoDocumentoId') || ''

  const handleNumeroDocumentoChange = useCallback(
    (value: string, docType: any[]) => {
      setValue('numeroDocumento', value)
      clearTimeout(numeroDocumentoChangeTimeout)
      numeroDocumentoChangeTimeout = setTimeout(() => {
        if (value?.length > 0) {
          const input = document.querySelector('input[name="numeroDocumento"]')
          if (input) {
            input.dispatchEvent(new KeyboardEvent('keydown', {key: 'Enter'}))
            if (!isDocTypeWithPersonLookupFlow(watch('tipoDocumentoId'), docType)) {
              if (numeroDocumento.length === Number(maxLength)) {
                input.addEventListener('keydown', handleEnterKey as EventListener)
              }
            } else {
              input.addEventListener('keydown', handleEnterKey as EventListener)
            }
          }
        }
      }, 2000)
    },
    [setValue, tipoDocumento, docType, maxLength, numeroDocumento],
  )

  const handleEnterKey = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      setLoading(true)

      getPersonList()
      const input = document.querySelector('input[name="numeroDocumento"]')
      if (input) {
        input.removeEventListener('keydown', handleEnterKey as EventListener)
      }
    }
  }

  useEffect(() => {
    if (!currentTabItem.idToEdit) {
      if (docType.length > 0) {
        handleNumeroDocumentoChange(numeroDocumento, docType)
      }
      const input = document.querySelector('input[name="numeroDocumento"]')
      if (input) {
        input.addEventListener('keydown', handleEnterKey as EventListener)
      }
      return () => {
        if (input) {
          input.removeEventListener('keydown', handleEnterKey as EventListener)
        }
      }
    }
  }, [numeroDocumento, handleNumeroDocumentoChange, docType, currentTabItem.idToEdit])

  const getPersonList = async () => {
    const currentTipoDocumento = watch('tipoDocumentoId')
    const currentNumeroDocumento = watch('numeroDocumento')

    if (isDocTypeWithPersonLookupFlow(currentTipoDocumento, docType)) {
      if (!currentNumeroDocumento || currentNumeroDocumento.length < 7) {
        setLoading(false)
        return
      }
    } else if (currentNumeroDocumento.length !== Number(maxLength)) {
      setLoading(false)
      return
    }
    let obj: PersonModel = {
      tipoDocumento: currentTipoDocumento,
      numeroDocumento: currentNumeroDocumento,
    }
    const response = await getPerson(obj, 1)
    const data = response.data.data
    if (data.length > 0) {
      setValue('personaId', data[0]?.id)
      setValue('nombres', data[0]?.nombres)
      setValue('apellidoPaterno', data[0]?.apellidoPaterno)
      setValue('apellidoMaterno', data[0]?.apellidoMaterno)
      setValue('telefono', data[0]?.telefono ?? '')
      setValue('usuario', data[0]?.numeroDocumento ?? '')
      setValue('email', data[0]?.email ?? '')
      // La empresa (subcontratista) viene en los documentos de la persona (getAllDocument),
      // no en getPerson. Se extrae del documento y se pinta el select async {value,label}.
      // Se prioriza el documento por defecto (el que se usará como "Cod. de trabajador").
      const documents = await getDocumentByPersonList(data[0]?.id, '')
      const docEmpresa =
        documents?.find((d: any) => d?.docDefault === 'SI' && d?.empresaId) ??
        documents?.find((d: any) => d?.empresaId)
      console.log('[getPersonList] empresa desde documento =>', docEmpresa?.empresa, '| empresaId =>', docEmpresa?.empresaId)
      if (docEmpresa?.empresaId) {
        setValue('empresaSubcontratistaId', docEmpresa.empresaId)
        setEmpresaSubcontratistaOption({
          value: docEmpresa.empresaId,
          label: docEmpresa.empresa,
        })
        getCECOList({empresaId: docEmpresa.empresaId}, 999)
      } else {
        setValue('empresaSubcontratistaId', '')
        setEmpresaSubcontratistaOption(null)
      }
      setLoading(false)
      setDetailDocument(null)
    } else {
      setLoading(false)
      setDetailDocument({
        tipoDocumento: currentTipoDocumento,
        numeroDocumento: currentNumeroDocumento,
        maxLength: maxLength,
      })
    }
  }

  const getDocumentByPersonList = async (personaId: any, valueEmpresaId: any) => {
    try {
      const {data: response} = await getDocumentByPerson(1, personaId, valueEmpresaId)
      const data = response.data
      console.log('[getDocumentByPersonList] documentos =>', data)
      const mappedSites = data.map((item) => ({
        value: item.id,
        label: item.nombreTipoDocumento + ' ' + item.numeroDocumento,
        docDefault: item.docDefault === 'SI' ? true : false,
      }))
      if (!response.error) {
        setDocumentoPersona(mappedSites)
      }
      return data
    } catch (error) {
      setLoading(false)
      return []
    }
  }

  const getEnterpriseByIdValues = async () => {
    try {
      setLoadUser(true)
      const response = await getUserById(currentTabItem.idToEdit)
      const data = response.data.data
      type UserModelKeys = keyof UserModel

      for (const fieldName in initValues) {
        if (initValues.hasOwnProperty(fieldName)) {
          if (data.hasOwnProperty(fieldName)) {
            if (data[fieldName as UserModelKeys]) {
              if (fieldName === 'empresaSubcontratistaId') {
                let valueEmpresaId = data['empresaSubcontratistaId']
                let valuepersonaId = data['personaId']
                getCECOList({empresaId: valueEmpresaId}, 9999)
                if (valuepersonaId) {
                  setValue('personaId', valuepersonaId)
                  setValue('empresaSubcontratistaId', valueEmpresaId)
                  getDocumentByPersonList(valuepersonaId, valueEmpresaId)
                  setLoading(false)
                  setDetailDocument(null)
                }
              } else if (fieldName === 'nombreUsuario') {
                let valueUuser = data['nombreUsuario']
                setValue('usuario', valueUuser)
              } else if (fieldName === 'campoadicionalFec1') {
                let valueDep = data[fieldName as UserModelKeys]
                if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                  const fechaLocal = new Date(valueDep)
                  const formattedDate = fechaLocal.toISOString().slice(0, 10)
                  setValue(fieldName, formattedDate)
                }
              } else if (fieldName === 'campoadicionalFec2') {
                let valueDep = data[fieldName as UserModelKeys]
                if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                  const fechaLocal = new Date(valueDep)
                  const formattedDate = fechaLocal.toISOString().slice(0, 10)
                  setValue(fieldName, formattedDate)
                }
              } else if (fieldName === 'esComensal') {
                let valueComensal = data['esComensal']
                setValue('esComensal', valueComensal)
                setValue('createComensal', valueComensal)
              } else if (fieldName === 'esHuesped') {
                let valueHuesped = data['esHuesped']
                setValue('esHuesped', valueHuesped)
                setValue('createHuesped', valueHuesped)
              } else if (fieldName === 'tienePermisos') {
                let valueHuesped = data['tienePermisos']
                setValue('permisos', valueHuesped)
                setValue('tienePermisos', valueHuesped)
              } else if (fieldName === 'tieneAccesoComedor') {
                let valueAccesoComedor = data['tieneAccesoComedor']
                setValue('tieneAccesoComedor', valueAccesoComedor)
              } else {
                setValue(fieldName, data[fieldName as UserModelKeys])
              }
            } else {
              setValue(fieldName, '')
            }
          }
        }
      }

      const [contratanteOption, subcontratistaOption] = await Promise.all([
        getEnterpriseOptionById(data['empresaContratanteId']),
        getEnterpriseOptionById(data['empresaSubcontratistaId']),
      ])
      setEmpresaContratanteOption(contratanteOption)
      setEmpresaSubcontratistaOption(subcontratistaOption)
    } catch (error) {
    } finally {
      setLoadUser(false)
    }
  }

  useEffect(() => {
    getDocTypeList()
    getStatusUserList()
    getStatusAccessList()
    setValue('estado', 'ACT')
  }, [])

  useEffect(() => {
    if (detailDocument) {
      setShowModalNew(true)
    }
  }, [detailDocument])

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      reset()
      setValue('createComensal', null)
      setValue('createHuesped', null)
      setValue('permisos', null)
      setValue('esComensal', null)
      setValue('esHuesped', null)
      setValue('tienePermisos', null)
      getEnterpriseByIdValues()
    } else {
      setEmpresaContratanteOption(null)
      setEmpresaSubcontratistaOption(null)
    }
  }, [currentTabItem.idToEdit])

  useEffect(() => {
    if (!currentTabItem.idToEdit) {
      if (ceco.length > 0 && empresaSubcontratistaId) {
        setValue('centroCosto', ceco[0]?.value)
      } else {
        setValue('centroCosto', '')
        setError('centroCosto', {})
      }
    }
  }, [currentTabItem.idToEdit, ceco, empresaSubcontratistaId])

  useEffect(() => {
    if (!currentTabItem.idToEdit) {
      if (documentoPersona.length > 0 && empresaSubcontratistaId) {
        const filteredDefault = documentoPersona.find((item: any) => item.docDefault === true)
        if (filteredDefault) {
          setValue('documentoPersonaIdentificadorId', filteredDefault?.value)
        } else {
          setValue('documentoPersonaIdentificadorId', documentoPersona[0]?.value)
        }
      } else {
        setValue('documentoPersonaIdentificadorId', '')
        setError('documentoPersonaIdentificadorId', {})
      }
    }
  }, [currentTabItem.idToEdit, documentoPersona, empresaSubcontratistaId])

  const handleGetMaxLength = (val: any) => {
    const value = val ? val : ''
    setMaxLength(value.length)
    setValue('numeroDocumento', '')
    setError('numeroDocumento', {})
  }

  const handleGetCeco = (val: any) => {
    const value = val ? val : ''
    setValue('empresaSubcontratistaId', value.value)
    setError('empresaSubcontratistaId', {})
    setEmpresaSubcontratistaOption(val ?? null)
    getCECOList({empresaId: value.value}, 999)
    getDocumentByPersonList(watch('personaId'), value.value)
  }

  const handleGetEmpresaContratante = (val: any) => {
    const value = val ? val : ''
    setValue('empresaContratanteId', value.value)
    setError('empresaContratanteId', {})
    setEmpresaContratanteOption(val ?? null)
  }

  const loadOptionsEmpresa = useCallback(async (inputValue: string) => {
    if (!inputValue || inputValue.trim().length < ENTERPRISE_SEARCH_MIN_LENGTH) {
      return []
    }
    return getEnterpriseSearchOptions(inputValue.trim())
  }, [])

  let isDisabled = currentTabItem.idToEdit ? true : false
  let typeName = isDocTypeAlphaNumeric(watch('tipoDocumentoId'), docType)
    ? 'alphaNumeric'
    : 'numeric'

  const handleChangeCheck = (e: any) => {
    const value = e.target.checked
    setValue('createHuesped', value)
    setValue('createComensal', value)
  }

  const disabledMainCheckPermission = watch('esComensal') || watch('esHuesped')

  if (loadUser)
    return (
      <div className='sdx_form card p-4 h-200px'>
        <KTableLoading />
      </div>
    )
  return (
    <ContentForm title={TITLE_FORM_USER}>
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Tipo de Doc. Id.'
            name='tipoDocumentoId'
            data={docType}
            onChangeValue={handleGetMaxLength}
            disabled={isDisabled}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputNumberWrapper
            labelText='Número de Doc. Id.'
            name='numeroDocumento'
            textPlaceholder='Escribe el nro de documento'
            maxLength={maxLength}
            disabled={isDisabled}
            type={typeName}
            required
          />
        </div>
        <>
          {loading && <KTableLoading />}
          <div className='col-sm-12 col-md-4 col-xl-3'>
            <InputTextWrapper
              labelText='Nombres'
              name='nombres'
              textPlaceholder='Escribe el nombre'
              readOnly
            />
          </div>
          <div className='col-sm-12 col-md-4 col-xl-3'>
            <InputTextWrapper
              labelText='Apellido Paterno'
              name='apellidoPaterno'
              textPlaceholder='Escribe el apellido paterno'
              readOnly
            />
          </div>
          <div className='col-sm-12 col-md-4 col-xl-3'>
            <InputTextWrapper
              labelText='Apellido Materno'
              name='apellidoMaterno'
              textPlaceholder='Escribe el apellido materno'
              readOnly
            />
          </div>
          <div className='col-sm-12 col-md-4 col-xl-3'>
            <InputTextWrapper
              labelText='Nombre de usuario'
              name='usuario'
              textPlaceholder='Escribe el usuario'
              disabled={isDisabled}
              type='alphaNumeric'
              Uppercase={false}
              required
            />
          </div>
          <div className='col-sm-12 col-md-4 col-xl-3'>
            <InputNumberWrapper
              labelText='Teléfono'
              name='telefono'
              textPlaceholder='Escribe el teléfono'
              type='telephone'
              required
            />
          </div>
          <div className='col-sm-12 col-md-4 col-xl-3'>
            <InputTextWrapper
              labelText='Correo'
              name='email'
              textPlaceholder='Escribe el correo'
              type='any'
              required
            />
          </div>
        </>
      </div>
      <hr className='divider' />
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Estado Acceso' name='estadoAcceso' data={statusAccess} required disabled={!isAllowed('PERMISO/EDITAR_ESTADO_ACCESO')}/>
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Estado' name='estado' data={statusUser} required/>
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectAsyncWrapper
            labelText='Empresa Contratista'
            name='empresaContratanteId'
            loadOptions={loadOptionsEmpresa}
            onChangeValue={handleGetEmpresaContratante}
            textPlaceholder='Escribe al menos 4 letras...'
            value={empresaContratanteOption}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectAsyncWrapper
            labelText='Empresa Subcontratista'
            name='empresaSubcontratistaId'
            loadOptions={loadOptionsEmpresa}
            onChangeValue={handleGetCeco}
            textPlaceholder='Escribe al menos 4 letras...'
            value={empresaSubcontratistaOption}
            required
          />
        </div>

        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Cod. de trabajador'
            name='documentoPersonaIdentificadorId'
            data={documentoPersona}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Ceco' name='centroCosto' data={ceco} required />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper labelText='Cargo' name='cargo' textPlaceholder='Escribe el cargo' />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-2 d-flex align-items-center'>
          <CheckWrapper name='envioCorreo' nameCheck='Enviar correo' className='h-100' />
        </div>
      </div>
      <div className='row my-5'>
        <div className='col-sm-12 col-md-4 col-xl-4 d-flex align-items-center'>
          <CheckWrapper
            name='permisos'
            nameCheck={
              <p className='d-flex flex-column mb-0'>
                <span className='fs-7'>
                  Creación automática de perfiles(Comensal, huésped y usuario de lavandería)
                </span>
                <span className='fs-9'>*Aplica a todos los campamentos</span>
              </p>
            }
            className='h-100'
            onchange={handleChangeCheck}
            disabled={disabledMainCheckPermission}
          />
          {currentTabItem.idToEdit && (
            <div
              style={{
                width: '15px',
                height: '15px',
                border: '1px solid black',
                backgroundColor: watch('colorPermisos'),
                borderRadius: '50%',
                marginLeft: '10px',
              }}
            ></div>
          )}
        </div>
        <div className='col-sm-12 col-md-4 col-xl-2 d-flex align-items-center'>
          <CheckWrapper
            name='createHuesped'
            nameCheck='Crear Huésped'
            className='h-100'
            disabled={watch('esHuesped')}
          />
          {currentTabItem.idToEdit && (
            <div
              style={{
                width: '15px',
                height: '15px',
                border: '1px solid black',
                backgroundColor: watch('colorHuesped'),
                borderRadius: '50%',
                marginLeft: '10px',
              }}
            ></div>
          )}
        </div>
        <div className='col-sm-12 col-md-4 col-xl-2 d-flex align-items-center'>
          <CheckWrapper
            name='createComensal'
            nameCheck='Crear Comensal'
            className='h-100'
            disabled={watch('esComensal')}
          />
          {currentTabItem.idToEdit && (
            <div
              style={{
                width: '15px',
                height: '15px',
                border: '1px solid black',
                backgroundColor: watch('colorComensal'),
                borderRadius: '50%',
                marginLeft: '10px',
              }}
            ></div>
          )}
        </div>
        {currentTabItem.idToEdit && (
          <div className='col-sm-12 col-md-4 col-xl-2 d-flex align-items-center'>
            <CheckWrapper
              name='tieneAccesoComedor'
              nameCheck='Acceso a comedor'
              className='h-100'
              disabled
            />
            <div
              style={{
                width: '15px',
                height: '15px',
                border: '1px solid black',
                backgroundColor: watch('colorAccesoComedor'),
                borderRadius: '50%',
                marginLeft: '10px',
              }}
            ></div>
          </div>
        )}
      </div>
      <hr className='divider' />
      {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      <AditionalForm />
      <AddPerson
        show={showModalNew}
        setShow={setShowModalNew}
        getList={getPersonList}
        detailDocument={detailDocument}
        setDetailDocument={setDetailDocument}
      />
    </ContentForm>
  )
}

export default User
